
import $ from 'jquery'
export default {
    data() {
        return {
            colorLinearConfig: {
                blue: ["#00AAFF", "#0064EC"],
                gray: ["#29CCBE", "#0064EC"],
                yellow: ["#FF9700", "#fcd72a"],
                red: ["#FF5040", "#7e158e"],
                green: ["#36CBD9", "#0F9080"],
                greenL: ["#1E3C98", "#0064EC"],

            },
            colorLegendConfig: {
                blue: "#00AAFF",
                yellow: "#FF9700",
                green: "#36CBD9",
                greenPink: "#4ECB73",
                red: "#FF5040", 
                gray: '#29CCBE',
                greenL: '#29CCBE',
                c33CC66:'#33CC66',
                cD9BE36:'#D9BE36',
                cFF5040:'#FF5040',
                c36CBD9:'#36CBD9',
                c00AAFF:"#00AAFF", 
                c3054BF:"#3054BF",
                c60BF68:"#60BF68",
                c1E3C98:"#1E3C98",
                cE66767:"#E66767",
                cCCAE52:"#CCAE52",
                c597EF7:"#597EF7",
                cFFA940:"#FFA940",
                c96C4F6:"rgba(89,126,247,0.5)"
            },
            xAxisTemplate:
            {
                type: 'category',
                axisLabel: {
                    color: "#2490C2"
                },
                axisLine: { //0刻度线
                    lineStyle: {
                        color: '#11255c'
                    },

                },
                axisTick: { //底部刻度短线，跟label接近的地方
                    lineStyle: {
                        color: '#11255c'
                    }
                },
                splitLine: {
                    show :false,
                    lineStyle: { // grid内的分隔线
                        color: '#11255c',
                        type: "dotted",
                    },

                },
            }
            ,
            yAxisTemplate:
            {
                nameTextStyle: {
                    color: "#2490C2",
                    padding: [10, 0, 0, 0]
                },
                type: 'value',
                axisLabel: {
                    color: "#2490C2"
                },
                axisLine: { //0刻度线
                    lineStyle: {
                        color: '#11255c'
                    },
                },
                axisTick: { //底部刻度短线，跟label接近的地方
                    lineStyle: {
                        color: '#11255c'
                    }
                },
                splitLine: {
                    show :false,
                    lineStyle: { // grid内的分隔线
                        color: '#11255c',
                        type: "dotted",
                    }
                },

            }
            ,
        }
    },
    methods: {
        setChartColor: function (c) {
            var cLinear = [];
            var cLegend = [];
            for (let i = 0; i < c.length; i++) {
                cLinear.push(this.colorLinearConfig[this.colorSet[i]]);
                cLegend.push(this.colorLegendConfig[this.colorSet[i]]);
            }
            return {
                cLinear: cLinear,
                cLegend: cLegend,
            }
        },

        setChart: function (chartObj, opt, param) {
            if (!chartObj) {
                return;
            }
            param = arguments[2] ? arguments[2] : null;
            var defaultParam = {
                silent: true
            };
            if (param === null) {
                chartObj.setOption(opt, defaultParam);
            } else {
                var doParam = $.extend(defaultParam, param);
                chartObj.setOption(opt, doParam);
            }
        }
    },

};
